import { fetchAuthSession } from "aws-amplify/auth";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAuthContext } from "../context/AmplifyContext";
import { useStoresContext } from "../context/StoresContext";
import { useStripeSubscription } from "../context/StripeSubscriptionContext";
import { LoadingOverlay } from "../src/components/AppComponents/LoadingOverlay";
import { getShopFromLocalStorage, saveShopToLocalStorage } from "../src/utils/shopStorage";

function Home() {
  const router = useRouter();
  const { authedUser } = useAuthContext();
  const { stores, isStoresLoading, selectedStore } = useStoresContext();
  const { refetchSubscription } = useStripeSubscription();

  const { sessionID } = router.query;
  if (sessionID) {
    fetch("/api/billings", {
      method: "POST",
      body: JSON.stringify({ sessionID }),
    }).then(refetchSubscription);
  }

  // Save shop param to local storage if present
  useEffect(() => {
    const { shop } = router.query;
    if (shop && typeof shop === "string") {
      saveShopToLocalStorage(shop);
    }
  }, [router.query]);

  // Handle redirections based on authentication and shop parameter
  useEffect(() => {
    const handleNavigation = async () => {
      if (router) {
        // Handle authenticated users
        if (!isStoresLoading && authedUser) {
          const { query } = router;
          // Check shop parameter from URL or local storage
          const shopValue = (query.shop as string) || getShopFromLocalStorage();

          let redirectPath;

          if (selectedStore?.isOnboarding || !stores.length || shopValue) {
            // Redirect to onboarding if:
            // - Selected store is in onboarding mode
            // - User has no stores
            // - Shop parameter is present (URL or local storage)
            redirectPath = {
              pathname: "/onboarding",
              query,
            };
          } else {
            // Otherwise redirect to dashboard
            redirectPath = {
              pathname: "/dashboard",
              query,
            };
          }

          router.push(redirectPath);
          return;
        }

        // Handle unauthenticated users
        try {
          const session = await fetchAuthSession();
          if (!session || !session.userSub) {
            router.push({
              pathname: "/login",
              query: router.query,
            });
          }
        } catch (error) {
          router.push({
            pathname: "/login",
            query: router.query,
          });
        }
      }
    };

    handleNavigation();
  }, [authedUser, isStoresLoading, router, selectedStore?.isOnboarding, stores.length]);

  return <LoadingOverlay fullPage />;
}

export default Home;
